import React, { useState, useEffect } from 'react';
import { Text, Center, Spinner } from '@chakra-ui/react';
import CompaniesApi from 'api/companies';
import OperationLocationAPI from 'api/operationlocation';
import Form from './storeForm';
import { useLocation } from 'react-router-dom';

export default function AddNewStoreForm(props) {
  const [operationLocationsList, setOperationLocationsList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companiesFetched, setcompaniesFetched] = useState(false);
  const [operationLocationsFetched, setOperationLocationsFetched] =
    useState(false);
  const companyId = IdFromUrl(window.location.href);
  // console.log('Company ID = ', companyId);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  const FetchCompaniesList = async () => {
    try {
      setLoading(true);
      let response = await CompaniesApi.List({
        sort: 'name:asc',
      });
      response = response.data;
      setcompaniesFetched(true);
      companiesFetched && operationLocationsFetched && setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        // console.log(response.data);
        setCompaniesList(response?.data?.list);
      } else {
        setCompaniesList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchCompaniesList();
  }, []);

  const fetchOperationLocationsList = async () => {
    try {
      setLoading(true);
      let response = await OperationLocationAPI.List({
        sort: 'name:asc',
      });
      response = response.data;
      setOperationLocationsFetched(true);
      companiesFetched && operationLocationsFetched && setLoading(false);
      if (response.status_code == 200 && response?.data?.list?.length > 0) {
        setOperationLocationsList(response?.data?.list);
      } else {
        setOperationLocationsList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchOperationLocationsList();
  }, []);

  return (
    <>
      {loading && companiesList && operationLocationsList ? (
        <Form
          operationLocationsList={operationLocationsList}
          companiesList={companiesList}
          companyId={companyId}
        />
      ) : (
        <>
          <Center
            mt={60}
            width='100%'
            // bgColor='red'
          >
            <Spinner size='xl' />
          </Center>
          <Text
            fontSize='2xl'
            fontWeight='700'
            mt={10}
            p={4}>
            Loading Companies and Operation Locations....
          </Text>
          <Text
            fontSize='md'
            fontWeight='500'
            p={4}
            pb={0}>
            If Form fails to load please check if any Operation Location or
            Company exist.
          </Text>
          <Text
            fontSize='md'
            fontWeight='500'
            p={4}
            pt={1}>
            Branch cannot be made without any pre existing Operation Location or
            Company.
          </Text>
        </>
      )}
    </>
  );
}
